module.exports = __webpack_public_path__ + "img/md-card.37ae7a5d.svg";